import { createStyles } from '@mantine/core';

import { RAIL_CARD_WIDTH, RAIL_CARD_WIDTH_DESKTOP } from '../../constants/rail';

export const useStyles = createStyles((theme) => ({
  module: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._16,
  },
  hidden: {
    display: 'none',
  },
  skeletonRail: {
    display: 'grid',
    gap: theme.other.spacing._8,
    gridAutoFlow: 'column',
    gridAutoColumns: RAIL_CARD_WIDTH,
    gridTemplateRows: 'auto',

    overflow: 'hidden',

    [theme.fn.largerThan('md')]: {
      gridAutoColumns: RAIL_CARD_WIDTH_DESKTOP,
      gap: theme.other.spacing._16,
    },
  },
}));
